/* ==========================================================================
   smellBgone Subscribe & Save plan builder — size + delivery-frequency pills
   on the /pages/subscribe marketing cards. Ports the interactive parts of
   app/routes/subscribe.tsx (Pill state + price recompute) to vanilla JS.

   Reads a JSON blob ([data-sub-combos]) built by the section: for every
   available size × cadence combination it holds the fully money-formatted
   PriceTag markup (rendered server-side with the `money` filter), keyed
   variantId -> sellingPlanId (or "none") -> HTML. A pill click only ever
   swaps that pre-rendered markup into the page — money formatting never
   happens in JS. Works per-card so both product cards on the page (and any
   other instance) hold independent state.
   ========================================================================== */
(function () {
  function initCard(card) {
    if (card.__smbSubInit) return;
    card.__smbSubInit = true;

    var combosEl = card.querySelector('[data-sub-combos]');
    var combos = {};
    if (combosEl) {
      try {
        combos = JSON.parse(combosEl.textContent) || {};
      } catch (e) {
        combos = {};
      }
    }

    var sizeBtns = card.querySelectorAll('[data-sub-size]');
    var freqBtns = card.querySelectorAll('[data-sub-freq]');
    var priceWrap = card.querySelector('[data-sub-pricetag]');
    var cadenceLabelEl = card.querySelector('[data-sub-cadence-label]');
    var cta = card.querySelector('[data-sub-cta]');
    var ctaBaseHref = cta ? cta.getAttribute('href') : null;

    function activeBtn(list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].classList.contains('active')) return list[i];
      }
      return list[0] || null;
    }

    function render() {
      var sizeBtn = activeBtn(sizeBtns);
      var freqBtn = activeBtn(freqBtns);
      var sizeId = sizeBtn ? sizeBtn.getAttribute('data-sub-size') : null;
      var freqId = freqBtn ? freqBtn.getAttribute('data-sub-freq') : null;

      // Price — swap in the pre-rendered PriceTag HTML for this exact
      // size × cadence combo; never reformat money client-side.
      if (priceWrap && sizeId != null && freqId != null && combos[sizeId] && combos[sizeId][freqId] != null) {
        priceWrap.innerHTML = combos[sizeId][freqId];
      }

      // "Subscription price · <cadence>" caption follows the selected cadence.
      if (cadenceLabelEl && freqBtn) {
        var label = freqBtn.getAttribute('data-sub-freq-label') || '';
        cadenceLabelEl.textContent = label.toLowerCase();
      }

      // The CTA is a Shopify cart permalink (/cart/{variant}:{qty}) — a plain
      // link, no JS required, that adds the item and sends the browser
      // straight to checkout with the cadence pre-selected. Rebuilt here so
      // it always matches whichever size + cadence pill is active; the
      // server-rendered href (the default-pill combo) is the starting point.
      if (cta && ctaBaseHref && sizeId != null) {
        try {
          var url = new URL(ctaBaseHref, window.location.origin);
          var path = url.pathname.replace(/\/[^/]+:\d+$/, '/' + sizeId + ':1');
          if (freqId && freqId !== 'none') {
            url.searchParams.set('selling_plan', freqId);
          } else {
            url.searchParams.delete('selling_plan');
          }
          cta.setAttribute('href', path + url.search);
        } catch (e) {
          /* malformed base href — leave the CTA link untouched */
        }
      }
    }

    function bindGroup(list) {
      list.forEach(function (btn) {
        btn.addEventListener('click', function () {
          list.forEach(function (b) {
            b.classList.remove('active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('active');
          // The chosen chip says so to a screen reader too (polish,
          // 2026-10-04): the class alone only painted it.
          btn.setAttribute('aria-pressed', 'true');
          render();
        });
      });
    }

    bindGroup(sizeBtns);
    bindGroup(freqBtns);

    // Sync the price/CTA to whichever pills are marked active server-side.
    render();
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-sub-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
